<template>
    <div>
        <EmcBaseProgressBar v-if="loading" />

        <v-simple-table dense v-else>
            <template v-slot:default>
                <thead>
                    <tr>
                        <th>Unidade</th>
                        <th>Atividade</th>
                        <th class="text-center">Período</th>
                        <th class="text-center">CH</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in items" :key="item.id">
                        <td>{{ item.activity_offered.branch ? item.activity_offered.branch.name : '' }}</td>
                        <td>{{ item.activity_offered.name }}</td>
                        <td class="text-center">{{ period(item) }}</td>
                        <td class="text-center">{{ Number(item.work_load || 0) }}</td>
                    </tr>
                </tbody>
                <tfoot v-if="items.length > 0">
                    <tr>
                        <td colspan="3" class="text-right"><strong>Total:</strong></td>
                        <td class="text-center"><strong>{{ total }}</strong></td>
                    </tr>
                </tfoot>
            </template>
        </v-simple-table>
    </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import { useStore } from '@/composables/useStore'

// Atividades ofertadas em que o professor esta vinculado como "Professor da
// Atividade" (activity_offered_teacher_inscriptions), com a CH dele em cada uma.
const props = defineProps({
    teacher: { type: Object, required: true },
})

const store = useStore()
const items = ref([])
const loading = ref(true)

const total = computed(() => items.value.reduce((sum, item) => sum + Number(item.work_load || 0), 0))

function formatDate(date) {
    if (!date) return ''
    const [year, month, day] = String(date).substring(0, 10).split('-')
    return `${day}/${month}/${year}`
}

// Periodo da inscricao; sem datas, o da propria oferta.
function period(item) {
    const start = item.date_start || item.activity_offered.date_start
    const end = item.date_end || item.activity_offered.date_end
    return `${formatDate(start)} - ${formatDate(end)}`
}

function getData() {
    if (!props.teacher || !props.teacher.id) {
        return
    }

    loading.value = true

    store.dispatch('domainActivityOffered/ActionGetActivityOfferedTeacherInscriptions', {
        find_columns: { teacher_id: props.teacher.id },
        with: 'activityOffered.branch',
    })
        .then((res) => {
            // So ofertas ativas (mesmo criterio do extrato em PDF)
            items.value = (res.data || []).filter((item) => item.activity_offered && item.activity_offered.active)
        })
        .finally(() => {
            loading.value = false
        })
}

watch(() => props.teacher && props.teacher.id, getData, { immediate: true })
</script>

<style scoped>
table td {
    white-space: nowrap;
}
</style>
